import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/mocha/core',
            name: 'admin-mocha-core',
            component: () => import(/* webpackChunkName: "page-admin-mocha-core" */ `./index.vue`),
            meta: {
                data_for_admin_layout: {
                    data_for_history_tag: {
                        entity: {
                            name: "core"
                        }
                    },
                    data_for_breadcrumb: {
                        entity_list: [
                            {
                                name: "mocha"
                            },
                            {
                                name: "core"
                            }
                        ]
                    }
                }
            },

        },
    ],
};
